/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDailySummaryNotification extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDailySummaryNotification");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDailySummaryNotification.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDailySummaryNotification>): BackgroundJobPayloadForCostAnomalyDailySummaryNotification {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDailySummaryNotification(), model);
        BackgroundJobPayloadForCostAnomalyDailySummaryNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDailySummaryNotification>): BackgroundJobPayloadForCostAnomalyDailySummaryNotification {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDailySummaryNotification.newInstance(<BackgroundJobPayloadForCostAnomalyDailySummaryNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDailySummaryNotification) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDailySummaryNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDailySummaryNotification): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDailySummaryNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
